import {ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT, REDUCER_NAME} from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = state => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectAnamnesisListState = state => {
    return selectParentState(state).list
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectAnamnesisList = state => {
    return selectOwnState(state).anamnesisList
}

export const selectAnamnesisByTemplateKey = (state, templateKey) => {
    const anamnesisList = selectAnamnesisList(state)
    return anamnesisList[templateKey]
}

export const selectMedicalAssessment = (state) => {
    return selectAnamnesisByTemplateKey(state, ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT)
}

export const selectShowAnamnesis = state => {
    return selectOwnState(state).showAnamnesis
}

export const selectShowInfoLegendShown = state => {
    return selectOwnState(state).isInfoLegendShown
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/selector.js